import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getPermissions as getPermissionsService } from "../../services/PermissionsService";
import {
  PermissionsList,
  PermissionsState,
} from "../../interfaces/permissions-interface";

export const getPermissions = createAsyncThunk(
  "products/getPermissions",
  async (_, thunkAPI) => {
    const token = localStorage.getItem("idToken");

    if (!token) {
      return thunkAPI.rejectWithValue("No authentication token found.");
    }

    try {
      const permissions = await getPermissionsService();
      return permissions.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const permissionsSlice = createSlice({
  name: "permissions",
  initialState: {
    permissions: [] as PermissionsList,
    status: "idle",
    error: null,
  } as PermissionsState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPermissions.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getPermissions.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.permissions = action.payload;
        state.error = null;
      })
      .addCase(getPermissions.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

const permissionsSliceReducer = permissionsSlice.reducer;

export default permissionsSliceReducer;
